import Box from '@mui/material/Box'

const HMapLabel = ({ width, text, fontType }) => {
  const typographyType = fontType || 'h3'

  return (
    <Box
      sx={(theme) => ({
        color: theme.palette.tertiary.main,
        fontFamily: theme.typography[typographyType].fontFamily,
        fontSize: theme.typography[typographyType].fontSize,
        fontWeight: theme.typography[typographyType].fontWeight,
        width: width || '100%'
      })}
    >
      {text}
    </Box>
  )
}

export default HMapLabel
